const IconArrowRight = () => {
	return(
		<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M7.40353 0.223469C7.10542 -0.0745415 6.62207 -0.0744395 6.32406 0.223469C6.02584 0.521682 6.02584 1.00493 6.32416 1.30315L9.25744 4.23633L0.763232 4.23714C0.341661 4.23724 -1.28775e-05 4.57892 -1.29144e-05 5.00069C8.81382e-05 5.42226 0.341762 5.76383 0.763333 5.76383L9.25785 5.76302L6.32385 8.69682C6.02574 8.99493 6.02574 9.47838 6.32385 9.77639C6.47296 9.9254 6.66827 10 6.86369 10C7.059 10 7.25432 9.9254 7.40343 9.77649L11.6404 5.53962C11.7836 5.39651 11.864 5.20242 11.864 4.99988C11.8639 4.79734 11.7835 4.60335 11.6403 4.45994L7.40353 0.223469Z" fill="currentColor"/>
		</svg>

	)
}
export default IconArrowRight;